module.exports = __webpack_public_path__ + "img/search-button.e0fb6501.svg";